import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ListaEspecialidades from "./ListaEspecialidades";
import { Route, Redirect } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { sections } from "../utils/properties";
import generateReporteEstudiantesPDF from "../services/reportGenerator";
import generateReporteEstudiantesExcel from "../services/reportGeneratorExcel";
import { formatPhoneNumber } from "../utils/utils";
import { format, addDays, isValid, parse } from "date-fns";
import { CSVLink } from "react-csv";
import {
    getStatusStudentList,
    changeStatusEstudiante,
    getEstudiantes,
    getAgencias,
    getPermissions,
    filterStudents,
    getSpecialties,
    getEspecialidades,
    getSupervisor,
    getInterest,
    payCommission as payCommissionUtil,
    allowOnlyNumbers,
} from "../utils/utils";

let optionsSelectStatusStudent = [];
let optionsSelectAgencias = [];
let optionsSelectSpecialties = [];
let optionsSelectSupervisorList = [];
let filters = {};

const Estudiantes = () => {
    const history = useHistory();
    const [selected, setSelected] = useState([]);
    const [selectedAgencia, setSelectedAgencia] = useState([]);
    const [selectedSupervisorList, setSelectedSupervisorList] = useState([]);
    const [selectedSpecialties, setSelectedSpecialties] = useState([]);
    const [statusStudentList, setStatusStudentList] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);
    const [interesados, setInteresados] = useState([]);
    const [agencias, setAgencias] = useState([]);
    const [specialties, setSpecialties] = useState([]);
    const [filtroIdEspecialidad, setfiltroIdEspecialidad] = useState("");
    const [nombreEspecialidad, setNombreEspecialidad] = useState("");
    const [filtroNombres, setFiltroNombres] = useState("");
    const [filtroApellidos, setFiltroApellidos] = useState("");
    const [filtroTelefono, setFiltroTelefono] = useState("");
    const [filtroStatusStudent, setFiltroStatusStudent] = useState("0");
    const [filtroLimiteRegistros, setFiltroLimiteRegistros] = useState("");
    const [filtroFechaRegistroInicial, setFiltroFechaRegistroInicial] = useState("");
    const [filtroFechaRegistroFinal, setFiltroFechaRegistroFinal] = useState("");
    const [filtroFechaAgendaInicial, setFiltroFechaAgendaInicial] = useState("");
    const [filtroFechaAgendaFinal, setFiltroFechaAgendaFinal] = useState("");
    const [filtroFechaLlamadaInicial, setFiltroFechaLlamadaInicial] = useState("");
    const [filtroFechaLlamadaFinal, setFiltroFechaLlamadaFinal] = useState("");
    const [filtroAgencia, setFiltroAgencia] = useState("");
    const [permissions, setPermissions] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [specialtiesToPayCommission, setSpecialtiesToPayCommission] = useState("");


    useEffect(() => {
        let promisesArray = [];
        setShowLoader(true);
        promisesArray.push(getStatusStudentList());
        promisesArray.push(getAgencias());
        promisesArray.push(getSpecialties());
        promisesArray.push(getPermissions());
        promisesArray.push(getSupervisor());
   

        Promise.all(promisesArray)
            .then((values) => {
                let statusStudentList = values[0];
                let agencies = values[1].filter((agency) => agency.age_status === "1");
                let specialties = values[2];
                let permissions = values[3];
                let supervisorList = values[4];

                setStatusStudentList(statusStudentList);
                setAgencias(agencies);
                setSpecialties(specialties);
                setPermissions(permissions);
                setSupervisorList(supervisorList);

                optionsSelectStatusStudent.length = 0;
                statusStudentList.map((statusStudent) => {
                    optionsSelectStatusStudent.push({
                        label: statusStudent.name,
                        value: statusStudent.id,
                    });
                    //setSelected(optionsSelectStatusStudent);
                });

                optionsSelectSupervisorList.length = 0;
                supervisorList.map((supervisor) => {
                    optionsSelectSupervisorList.push({
                        label: supervisor.name_supervisor,
                        value: supervisor.id_supervisor,
                    });
                    setSelectedSupervisorList(optionsSelectSupervisorList);
                });

                optionsSelectAgencias.length = 0;
                agencies.map((agency) => {
                    optionsSelectAgencias.push({
                        label: agency.age_nombre,
                        value: agency.age_id,
                    });
                    //setSelectedAgencia(optionsSelectAgencias);
                });


                optionsSelectSpecialties.length = 0;
                specialties.map((specialty) => {
                    optionsSelectSpecialties.push({
                        label: specialty.esp_nombre,
                        value: specialty.esp_id,
                    });
                    //setSelectedSpecialties(optionsSelectSpecialties);
                });

                

                if (
                    !(
                        permissions.length > 0 &&
                        permissions.some((e) => e.id_section === sections.LISTA_ESTUDIANTES)
                    )
                ) {
                    history.push("/bienvenido");
                }
            })
            .then(() => {
                filters = JSON.parse(localStorage.getItem("filters"));
                if (filters !== "" && filters !== null) {
                    setSelectedAgencia(JSON.parse(filters.agencia));
                    setSelectedSpecialties(JSON.parse(filters.idEspecialidad));
                    setSelectedSupervisorList(JSON.parse(filters.supervisor));
                    setSelected(JSON.parse(filters.statusStudent));
                    setFiltroLimiteRegistros(filters.limiteRegistros);
                    filter(filters);
                } else {
                    getEstudiantes().then((estudiantes) => {
                        setInteresados(estudiantes);
                        setShowLoader(false);
                        //setSelected(optionsSelectStatusStudent);
                    });
                }
            });
    }, []);

    function cleanFilters() {
        let filters = {
            idClient: "",
            nombres: "",
            apellidos: "",
            telefono: "",
            idEspecialidad: JSON.stringify(optionsSelectSpecialties),
            limiteRegistros: 100,
            fechaRegistroInicial: "",
            fechaRegistroFinal: "",
            agencia: JSON.stringify(optionsSelectAgencias),
            statusStudent: JSON.stringify(optionsSelectStatusStudent),
            supervisor: JSON.stringify(optionsSelectSupervisorList),
            fechaAgendaInicial: "",
            fechaAgendaFinal: "",
            fechaLlamadaInicial: "",
            fechaLlamadaFinal: "",
            hasCommission: "",
        };
        localStorage.setItem("filters", JSON.stringify(filters));
        document.getElementById("idClient").value = "";
        document.getElementById("name").value = "";
        document.getElementById("lastname").value = "";
        document.getElementById("phone").value = "";
        document.getElementById("registrationStartDate").value = "";
        document.getElementById("registrationEndDate").value = "";
        document.getElementById("scheduledStartDate").value = "";
        document.getElementById("scheduledEndDate").value = "";
        document.getElementById("callStartDate").value = "";
        document.getElementById("callEndDate").value = "";
        document.getElementById("limitRecords").value = 100;
        document.getElementById("hasCommission").value = "";
        setSelectedSpecialties([]);
        setSelected([]);
        setSelectedAgencia([]);
        setSelectedSupervisorList(optionsSelectSupervisorList);
        filter(filters);
    }

    function filtrar() {
        let filters = {
            idClient: document.getElementById("idClient").value,
            nombres: document.getElementById("name").value,
            apellidos: document.getElementById("lastname").value,
            telefono: document.getElementById("phone").value,
            idEspecialidad: JSON.stringify(selectedSpecialties),
            limiteRegistros:
                document.getElementById("limitRecords").options[
                    document.getElementById("limitRecords").selectedIndex].value,
            fechaRegistroInicial: document.getElementById("registrationStartDate").value,
            fechaRegistroFinal: document.getElementById("registrationEndDate").value,
            agencia: JSON.stringify(selectedAgencia),
            supervisor: JSON.stringify(selectedSupervisorList),
            statusStudent: JSON.stringify(selected),
            fechaAgendaInicial: document.getElementById("scheduledStartDate").value,
            fechaAgendaFinal: document.getElementById("scheduledEndDate").value,
            fechaLlamadaInicial: document.getElementById("callStartDate").value,
            fechaLlamadaFinal: document.getElementById("callEndDate").value,
            hasCommission:
                document.getElementById("hasCommission").options[
                    document.getElementById("hasCommission").selectedIndex].value
        };
        localStorage.setItem("filters", JSON.stringify(filters));
        filter(filters);
    }

    function filter(filters) {
        setShowLoader(true);
        setInteresados([]);
        filterStudents(filters).then((students) => {
            setInteresados(students);
            setShowLoader(false);
        });
    }

    let especialidadesCallback_listaEstudiantes = (
        idEspecialidad,
        nombreEspecialidad
    ) => {
        setfiltroIdEspecialidad(idEspecialidad);
        setNombreEspecialidad(nombreEspecialidad);
    };

    function payCommission(specialty) {
        let commission = {
            amount: 0,
            agency:
                document.getElementById("agencyCommission").options[
                    document.getElementById("agencyCommission").selectedIndex
                ].value,
            specialty: specialty,
        };
        payCommissionUtil(commission).then(() => {
            getInterest(specialty.id_cliente).then((interests) => {
                setSpecialtiesToPayCommission(interests);
            });
        });
    }

    return (
        <div>
            {permissions.length > 0 &&
                permissions.some((e) => e.id_section === sections.LISTA_ESTUDIANTES) && 
                (
                    <div>
                        <div>
                            <div className="row align-items-center">
                                <div className="col-6">
                                    <h3>
                                        <i className="bi-people"></i> <strong>Estudiantes</strong>
                                    </h3>
                                </div>
                                <div className="col-6 text-end">
                                    <Link to="/estudiante">
                                        <button type="button" className="btn btn-sm btn-outline-dark" >
                                            <i className="bi bi-person-plus"></i> Nuevo estudiante
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 mb-5">
                            <span className="card-header">Filtros</span>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-1">
                                        <label  className="text-secondary" htmlFor="name">Código:</label>
                                        <input onInput={(e) => allowOnlyNumbers(e)}
                                            defaultValue={(filters && filters.idClient) || ""}
                                            type="text" className="form-control" id="idClient"
                                            disabled={
                                                !permissions.some((e) => e.id_section === sections.FILTRO_CODIGO)
                                            }
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="name">Nombres:</label>
                                        <input defaultValue={(filters && filters.nombres) || ""}
                                            type="text" className="form-control" id="name"
                                            onChange={(e) => {
                                                setFiltroNombres(e.target.value);
                                            }}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_NOMBRE)}
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="especialidad">Apellidos:</label>
                                        <input defaultValue={(filters && filters.apellidos) || ""}
                                            type="text" className="form-control" id="lastname"
                                            onChange={(e) => {
                                                setFiltroApellidos(e.target.value);
                                            }}
                                            disabled={!permissions.some( (e) => e.id_section === sections.FILTRO_APELLIDO)}
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="especialidad">Telefono:</label>
                                        <input defaultValue={(filters && filters.telefono) || ""}
                                            type="text" className="form-control text-danger" id="phone"
                                            onChange={(e) => {setFiltroTelefono(e.target.value);}}
                                            onInput={(e) => formatPhoneNumber(e)}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_TELEFONO)}
                                        />
                                    </div>
                                    
                                    <div className="col-1"></div>

                                    <div className="col-1">
                                        <label  className="text-secondary" htmlFor="limite">Registros</label>
                                        <select id="limitRecords" className="form-select"
                                            onChange={(e) => { setFiltroLimiteRegistros(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_LIMITE)}>
                                            <option selected={filters && filters.limiteRegistros === "100"} value="100" >100</option>
                                            <option selected={filters && filters.limiteRegistros === "300"} value="300">300</option>
                                            <option selected={filters && filters.limiteRegistros === "500"} value="500">500</option>
                                            <option selected={filters && filters.limiteRegistros === "18446744073709551615"}value="18446744073709551615">Todos</option>
                                        </select>
                                    </div>

                                </div>

                                <br></br>

                                <div className="row mt-3">
                                    <div className="col-3">
                                        <label  className="text-secondary"  htmlFor="especialidad">Especialidad:</label>
                                        <MultiSelect
                                            id="specialty" options={optionsSelectSpecialties} value={selectedSpecialties} onChange={setSelectedSpecialties}
                                            labelledBy="Select" disableSearch={true}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_ESTADO_ESTUDIANTE)}
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="limite">Estatus de estudiante:</label>
                                        <div className="form-group">
                                            {statusStudentList.length > 0 && (
                                                <MultiSelect
                                                    id="statusStudent" options={optionsSelectStatusStudent} value={selected} onChange={setSelected}
                                                    labelledBy="Select" disableSearch={true} 
                                                    disabled={!permissions.some((e) =>e.id_section ===sections.FILTRO_ESTADO_ESTUDIANTE)}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="limite">Agencia:</label>
                                        <div className="form-group">
                                            <MultiSelect
                                                options={optionsSelectAgencias} value={selectedAgencia} onChange={setSelectedAgencia}
                                                labelledBy="Select" disableSearch={true}
                                                disabled={!permissions.some((e) => e.id_section === sections.FILTRO_AGENCIA)}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="col-3">
                                        <label  className="text-secondary" htmlFor="limite">Supervisor:</label>
                                        <div className="form-group">
                                            {supervisorList.length > 0 && (
                                                <MultiSelect
                                                    id="supervisor" options={optionsSelectSupervisorList} value={selectedSupervisorList}
                                                    onChange={setSelectedSupervisorList} labelledBy="Select" disableSearch={true}
                                                    disabled={!permissions.some((e) =>e.id_section ===sections.FILTRO_SUPERVISOR)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <br></br>

                                <div className="row mt-3">
                                    <div className="col-2">
                                        <label className="text-info" htmlFor="limite">Agendados desde</label>
                                        <input
                                            defaultValue={(filters && filters.fechaAgendaInicial) || ""}
                                            id="scheduledStartDate" type="date" className="form-control"
                                            onChange={(e) => {setFiltroFechaAgendaInicial(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_AGENDA)}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label  className="text-info"  htmlFor="limite">Agendados hasta</label>
                                        <input defaultValue={(filters && filters.fechaAgendaFinal) || ""}
                                            id="scheduledEndDate" type="date" className="form-control"
                                            onChange={(e) => {setFiltroFechaAgendaFinal(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_AGENDA)}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label className="text-success" htmlFor="limite">Próxima llamada desde</label>
                                        <input
                                            defaultValue={(filters && filters.fechaLlamadaInicial) || ""}
                                            id="callStartDate" type="date" className="form-control"
                                            onChange={(e) => {setFiltroFechaLlamadaInicial(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_LLAMAR)}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label  className="text-success"  htmlFor="limite">Próxima llamada hasta</label>
                                        <input defaultValue={(filters && filters.fechaLlamadaFinal) || ""}
                                            id="callEndDate" type="date" className="form-control"
                                            onChange={(e) => {setFiltroFechaLlamadaFinal(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_LLAMAR)}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label  className="text-warning"  htmlFor="limite">Creados desde</label>
                                        <input defaultValue={(filters && filters.fechaRegistroInicial) || ""}
                                            type="date" className="form-control" id="registrationStartDate"
                                            onChange={(e) => { setFiltroFechaRegistroInicial(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_REGISTRO)}
                                        />
                                    </div>

                                    
                                    <div className="col-2">
                                        <label  className="text-warning" htmlFor="limite">Creados hasta</label>
                                        <input defaultValue={(filters && filters.fechaRegistroFinal) || "" }
                                            type="date" className="form-control" id="registrationEndDate" 
                                            onChange={(e) => {setFiltroFechaRegistroFinal(e.target.value);}}
                                            disabled={!permissions.some((e) => e.id_section === sections.FILTRO_FECHA_REGISTRO)}
                                        />
                                    </div>


                                    <div className="visually-hidden">
                                        <label htmlFor="limite">Comisión</label>
                                        <select id="hasCommission" className="form-select" 
                                        disabled={!permissions.some((e) => e.id_section === sections.FILTRO_COMISION) }>
                                            <option selected={filters && filters.hasCommission === ""}value="">Pendiente</option>
                                            <option selected={filters && filters.hasCommission === "100"} value="100">Pagada </option>
                                        </select>
                                    </div>

                                </div>

                                <br></br>

                                <div className="row mt-3">

                                     <div className="col-3">
                                        <button type="button" className="btn btn-sm btn-danger mx-2" onClick={() => {cleanFilters(); }}>
                                            <i className="bi-trash"></i> Limpiar filtros
                                        </button>
                                    </div>

                                    <div className="col-6 text-center">
                                        <button className="btn btn-sm btn-success" onClick={() => generateReporteEstudiantesPDF(interesados)} >
                                            <i className="bi bi-file-earmark-arrow-down"></i> Generar Pdf
                                        </button>
                                        &nbsp;&nbsp; &nbsp;&nbsp;

                                        <CSVLink data={generateReporteEstudiantesExcel(interesados)} filename='data.csv'>
                                            <button className="btn btn-sm btn-warning">
                                                <i className="bi bi-file-earmark-arrow-down"></i> 
                                                &nbsp;&nbsp;Exportar  Csv
                                            </button>
                                        </CSVLink>
                                    </div>


                                    <div className="col-3 text-end">
                                        <button type="button" className="btn btn-sm btn-primary mx-2"
                                            onClick={() => { filtrar(); }} >
                                            <i className="bi-funnel"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filtrar &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {interesados.length > 0 ? (
                            <React.Fragment>
                                <div className="card my-5">
                                    <div className="card-header">
                                        <strong>Resultados</strong>
                                    </div>

                                    <div className="card-body">
                                        <table id="studentTable" className="table table-sm  table-hover align-middle">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 0 + "%" }}>Código</th>
                                                    <th className="col-1">Nombre</th>
                                                    <th className="col-1">Teléfono</th>
                                                    <th className="col-1">Agenda</th>
                                                    <th className="col-2">Especialidad</th>
                                                    <th className="col-3">Último comentario</th>
                                                    <th className="col-1"></th>
                                                    <th className="col-1"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {interesados
                                                    ? interesados.map((interesado) => {
                                                        let dateTemp = new Date(interesado.fecha_agenda);
                                                        if (dateTemp === "Invalid Date")
                                                            dateTemp = "fecha incorrecta";
                                                        else
                                                            dateTemp = format(dateTemp.setDate(dateTemp.getDate() + 1), "MMM dd, yyyy");

                                                        let dateTemp2 = new Date(interesado.fecha);
                                                            if (dateTemp2 === "Invalid Date")
                                                                dateTemp2 = "fec. incorrecta";
                                                            else if (dateTemp2 < '2000101')
                                                                dateTemp2 = "";
                                                            else
                                                                dateTemp2 = (interesado.fecha.substring(0, 16)).replace('T', ' ');
                                                                                 
                                                        return (
                                                            <tr key={interesado.cli_id}>
                                                                <td><small>{interesado.cli_id}</small></td>
                                                                <td><small>{interesado.cli_apellido + " " + interesado.cli_nombre}</small></td>
                                                                <td><small>{interesado.cli_telefono}</small></td>
                                                                <td><small>{dateTemp}</small></td>
                                                                <td><small>{interesado.esp_nombre}</small></td>
                                                                <td><small>{interesado.comentario}</small></td>
                                                                <td><small>{dateTemp2}</small></td>
                                                                <td className="text-end">
                                                                    <div className="btn-group">
                                                                        <Link to={"/estudiante/" + interesado.cli_id}>
                                                                            <button className="btn btn-secondary btn-sm btn-sm-rows" type="button">
                                                                                <i className="bi bi-eye"></i> Ver
                                                                            </button>
                                                                        </Link>
                                                                        <button type="button" className="btn btn-sm btn-dark dropdown-toggle dropdown-toggle-split btn-sm-rows" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                            <span className="visually-hidden">
                                                                                Toggle Dropdown
                                                                            </span>
                                                                        </button>
                                                                        <ul className="dropdown-menu">
                                                                            {
                                                                                permissions.length > 0 && permissions.some(
                                                                                    (e) => e.id_section === sections.EDITAR_ESTUDIANTE
                                                                                ) && (  <li>
                                                                                            <Link className="dropdown-item" to={ "/estudiante/edit/" + interesado.cli_id}>
                                                                                                <i className="bi bi-pencil"></i>{" "}
                                                                                                Editar
                                                                                            </Link>
                                                                                        </li>
                                                                                )
                                                                            }
                                                                            {
                                                                                permissions.length > 0 && permissions.some(
                                                                                    (e) => e.id_section === sections.ELIMINAR_ESTUDIANTE
                                                                                ) && (  <li>
                                                                                        <a className="dropdown-item hand-pointer"
                                                                                            onClick={() => {
                                                                                                if (window.confirm("¿Seguro que desea eliminar el estudiante?")) 
                                                                                                {
                                                                                                    changeStatusEstudiante([{ id: interesado.cli_id },
                                                                                                    ]).then(() => {
                                                                                                        filter(JSON.parse(localStorage.getItem("filters")));
                                                                                                    });
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-trash"></i>{" "}
                                                                                            Eliminar
                                                                                        </a>
                                                                                    </li>
                                                                                )}
                                                                            {permissions.length > 0 &&
                                                                                permissions.some((e) => e.id_section === sections.PAGAR_COMISION) && 
                                                                                (
                                                                                    <a className="dropdown-item hand-pointer" data-bs-toggle="modal" data-bs-target="#enrollModal"
                                                                                        onClick=
                                                                                        {(e) => {getInterest(interesado.cli_id).then((interests) =>
                                                                                            {
                                                                                                setSpecialtiesToPayCommission(interests);
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        Comisión
                                                                                    </a>
                                                                                )}
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                    : "loading.-.."}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </React.Fragment>
                        ) : showLoader ? (
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <div className="loader4"></div>
                                        <h5>Cargando registros</h5>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <h5>No existen registros.</h5>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

            <div className="modal fade" id="enrollModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel">
                                Pagar comisión
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ width: 0 + "%" }}>#</th>
                                        <th className="col-4">Especialidad</th>
                                        <th className="col-1">Estado</th>
                                        <th className="col-4">Agencia</th>
                                        <th className="col-2"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {specialtiesToPayCommission &&
                                        specialtiesToPayCommission.length > 0 &&
                                        specialtiesToPayCommission.map((specialty) => (
                                            <tr>
                                                <th scope="row">{specialty.esp_id}</th>
                                                <td>{specialty.esp_nombre}</td>
                                                <td>{specialty.status_interest_description}</td>
                                                <td>
                                                    {specialty.interest_status === 2 ? (
                                                        specialty.age_nombre
                                                    ) : (
                                                        <div className="form-group">
                                                            {agencias.length > 0 ? (
                                                                <select id="agencyCommission" className="form-select">
                                                                    {agencias.map((agencia, index) => {
                                                                        if (agencia.age_status === "1") {
                                                                            return (
                                                                                <option
                                                                                    selected={
                                                                                        specialty[0] &&
                                                                                        agencia.age_id ===
                                                                                        specialty[0].cli_agencia_crea
                                                                                    }
                                                                                    key={agencia.age_id}
                                                                                    value={agencia.age_id}
                                                                                >
                                                                                    {agencia.age_nombre}
                                                                                </option>
                                                                            );
                                                                        }
                                                                    })}
                                                                </select>
                                                            ) : (
                                                                <select className="form-select">
                                                                    <option>No disponible</option>
                                                                </select>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="text-end">
                                                    {specialty.interest_status === 2 ? 
                                                        ("Comisión pagada") : 
                                                        (
                                                            <button type="button" className="btn btn-sm btn-success"
                                                            onClick={() => {
                                                                payCommission(specialty);
                                                            }}
                                                        >
                                                            Pagar comisión
                                                        </button>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Estudiantes;
